import React, { useEffect, useMemo } from "react";
import toast from "react-hot-toast";
import styled from "styled-components";
import UserDelegatesSelect from "../../components/forms/selects/UserDelegatesSelect";
import { Button } from "../../components";
import { Badge, CenterArea } from "../../components/utilities";
import { usePersonalOutlookContext } from "../../hooks/PersonalOutlookContext";
import { Spinner } from "../../components/loaders";
import { ErrorMessage, ErrorMessageWrapper } from "../../components/messages";
import { DelegatedAccessTypes } from "../../helpers/constants";
import { toNString } from "../../helpers/guids";
import { openMailPopout } from "../../components/modals/email-popout";

const FolderItem = styled.div`
    &.active,
    &:hover {
        background-color: ${props => props.theme.body};
    }
`;

const PersonalEmailFolders = () => {
    const {
        fetchFolders,
        folders: { data, isError, isFetching },
        selectFolder,
        selectedFolderId,
        selectedMailUserId,
        setSelectedMailUserId,
        mailDelegateRightsResult
    } = usePersonalOutlookContext();

    const { data: mailDelegateRights,  isFetching: isFetchingMailDelegateRights } = mailDelegateRightsResult || {};

    const onNewEmailCreate = () => {
        if (!mailDelegateRights.writeMail) {
            toast.error('Unable to create new email as you do not have the correct rights to send an email as this person.');
            return;
        }
        openMailPopout('new', {
            masterAccountId: null,
            projectId: null,
            subject: '',
            body: '',
            attachments: [],
            from: toNString(selectedMailUserId),
            toRecipients: [],
            ccRecipients: [],
            bccRecipients: []
        }).then(() => {});
    };

    const reloadFolder = () => fetchFolders(selectedMailUserId);

    useEffect(reloadFolder, [selectedMailUserId]);

    const isDataLoading = useMemo(() => 
        isFetching === true ||
        isFetchingMailDelegateRights === true,
        [isFetching, isFetchingMailDelegateRights]
    );

    return (
        <React.Fragment>
            <div className="p-2">
                <UserDelegatesSelect
                    accessType={DelegatedAccessTypes.readMail}
                    defaultValue={selectedMailUserId}
                    onChange={({ value }) => setSelectedMailUserId(value)}
                />
            </div>
            {isError === true && (
                <ErrorMessageWrapper>
                    <ErrorMessage message="Error loading folders." retryCallback={reloadFolder} />
                </ErrorMessageWrapper>
            )}
            {isDataLoading && (
                <CenterArea>
                    <Spinner />
                </CenterArea>
            )}
            <div className="px-2 w-100">
                {data && data.length > 0 && !isFetchingMailDelegateRights && (
                    <React.Fragment>
                        {mailDelegateRights.writeMail && <Button className="w-100 mb-2" variant="primary" onClick={onNewEmailCreate}>New Email</Button>}
                        {data.map((el, i) => (
                            <FolderItem className={`d-flex p-2 my-2 w-100 rounded has-pointer ${selectedFolderId === el.id ? 'active' : ''}`} key={i} onClick={() => selectFolder(el.id)}>
                                <div>

                                </div>
                                <div className="d-flex align-items-center flex-fill">
                                    <span>{el?.displayName ?? ""}</span>
                                    {el.unreadItemCount > 0 && (
                                        <Badge className="mx-3" variant="danger">{el.unreadItemCount}</Badge>
                                    )}
                                </div>
                                {el.totalItemCount > 0 && (
                                    <div className="text-muted">
                                        <span>{el.totalItemCount}</span>
                                    </div>
                                )}
                            </FolderItem>
                        ))}
                    </React.Fragment>
                )}
            </div>
        </React.Fragment>
    );
};

export default PersonalEmailFolders;